import React from 'react';

export default ({ stimul, classes, pidsData }) => (
  <div className={`${classes.p10} ${classes.fw} ${classes.alignCenter}`}>
    {stimul.id ? (
      <div className={classes.mr10} style={{ fontWeight: '900' }}>
        {stimul.id}
      </div>
    ) : null}

    <div className={classes.mr20}>{stimul.text}</div>

    <div className={classes.alignCenter}>
      <div className={classes.mr10}>Pids: </div>

      <div>
        {stimul.pids && stimul.pids.length ? (
          stimul.pids.map((pid, pidIndex) => {
            return <span key={pidIndex}>{pidsData[pid] ? `${pidsData[pid]}, ` : 'No title'}</span>;
          })
        ) : (
          <span>None</span>
        )}
      </div>
    </div>
  </div>
);
